import React from 'react';
import AddEditCampaignForm from 'ui-component/Campaign/AddEditCampaignForm';

function AddCampaign () {
  return (
    <div>
      <AddEditCampaignForm title="Add Campaign" />
    </div>
  )
}

export default AddCampaign;